import { Sidebar } from './Sidebar';
import { Header } from './Header';

interface DashboardLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  customHeader?: React.ReactNode;
}

export function DashboardLayout({ children, title, subtitle, customHeader }: DashboardLayoutProps) {
  return (
    <div className="flex min-h-screen w-full bg-background">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        {customHeader ? (
          <div className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-10 px-4 lg:px-6 py-4">
            {customHeader}
          </div>
        ) : (
          <Header title={title} subtitle={subtitle} />
        )}
        <main className="flex-1 p-4 lg:p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
}
